<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="coffeeConfigForm">
        <div class="mt-5">
          <div class="form-row">
            <div class="col-md-3 mb-3">
              <label for="officeId">Office</label>
              <select id="officeId" class="form-control" formControlName="officeId">
                <option *ngFor="let office of offices" [value]="office.id">
                  {{ office.city + ', ' + office.address }}
                </option>
              </select>
            </div>
            <div class="col-md-4 mb-3">
              <label for="bookingOption">Option</label>
              <select id="bookingOption" class="form-control" formControlName="bookingOption">
                <option *ngFor="let bookingOption of bookingOptions" [value]="bookingOption">{{ bookingOption }}</option>
              </select>
            </div>
            <div class="col-md-3 mb-3">
              <label for="value">Cups count</label>
              <input type="text" class="form-control" formControlName="value" id="value" placeholder="Cups">
            </div>
          </div>
          <div class="modal-buttons text-center">
            <button type="button" class="btn btn-default add-edit-button" (click)="closeModal(coffeeConfigForm)">Save</button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{errorMessage}}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
